export default {
  type: 'Container',
  components: [
    {
      type: 'Component',
      skin: 'skins.viewer.VectorImageSkin',
      layout: {
        width: 36,
        height: 26,
        x: 32,
        y: 37,
        scale: 1,
        rotationInDegrees: 0,
        fixedPosition: false,
      },
      componentType: 'wysiwyg.viewer.components.VectorImage',
      metaData: {
        pageId: 'ik4zq',
      },
      parent: 'comp-kgt64g51',
      data: {
        type: 'VectorImage',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'ik4zq',
        },
        alt: '',
        svgId: '11062b_f9f049a81e824bf9b256cb8356eae5a4.svg',
        title: 'Email',
      },
      props: {
        type: 'VectorImageProperties',
        metaData: {
          schemaVersion: '1.0',
          autoGenerated: false,
          pageId: 'ik4zq',
        },
        displayMode: 'stretch',
        flip: 'none',
      },
      design: {
        type: 'VectorImageDesignData',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'ik4zq',
        },
        overrideColors: {
          color1: '#F74D4D',
        },
        shapeStyle: {
          opacity: 1,
          strokeWidth: 4,
          stroke: '#5E97FF',
          strokeOpacity: 1,
          enableStroke: false,
        },
      },
      transitions: {
        type: 'TransitionData',
        'timing-function': 'ease-in-out',
        duration: 0.4,
        delay: 0,
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'ik4zq',
        },
      },
      transformations: {
        type: 'TransformData',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'ik4zq',
        },
        origin: {
          x: {
            value: 50,
            type: 'percentage',
          },
          y: {
            value: 50,
            type: 'percentage',
          },
        },
      },
      scopedTransformations: {
        'variants-kgt64g65': {
          type: 'TransformData',
          scale: {
            x: 0.9,
            y: 0.9,
          },
          metaData: {
            isPreset: false,
            schemaVersion: '1.0',
            isHidden: false,
            pageId: 'ik4zq',
          },
        },
      },
      style: {
        type: 'ComponentStyle',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'ik4zq',
        },
        style: {
          properties: {},
          propertiesSource: {},
          groups: {},
        },
        componentClassName: 'wysiwyg.viewer.components.VectorImage',
        styleType: 'custom',
        skin: 'skins.viewer.VectorImageSkin',
      },
      mobileStructure: {
        layout: {
          width: 40,
          height: 29,
          x: 30,
          y: 35,
          scale: 1,
          rotationInDegrees: 0,
          fixedPosition: false,
        },
        metaData: {
          originalCompId: 'comp-kgt64g665',
          author: 'studio',
        },
      },
    },
  ],
  skin: 'wysiwyg.viewer.skins.area.CircleArea',
  layout: {
    width: 100,
    height: 100,
    x: 440,
    y: 133,
    scale: 1,
    rotationInDegrees: 0,
    fixedPosition: false,
  },
  componentType: 'mobile.core.components.Container',
  metaData: {
    pageId: 'ik4zq',
  },
  parent: 'ik4zq',
  variants: {
    'variants-kgt64g65': {
      componentId: 'comp-kgt64g51',
      type: 'Hover',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'ik4zq',
      },
    },
  },
  transitions: {
    type: 'TransitionData',
    'timing-function': 'ease-in-out',
    duration: 0.4,
    delay: 0,
    metaData: {
      isPreset: false,
      schemaVersion: '1.0',
      isHidden: false,
      pageId: 'ik4zq',
    },
  },
  scopedTransformations: {
    'variants-kgt64g65': {
      type: 'TransformData',
      zLayer: 'BELOW_PINNED',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'ik4zq',
      },
      rotate: 0,
    },
  },
  scopedStyles: {
    'variants-kgt64g65': {
      type: 'ComponentStyle',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'ik4zq',
      },
      style: {
        properties: {
          'alpha-bg': '1',
          'alpha-brd': '1',
          bg: 'rgba(255,255,255,1)',
          'boxShadowToggleOn-shd': 'false',
          brd: '#F75E5E',
          brw: '3',
          shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
        },
        propertiesSource: {
          'alpha-bg': 'value',
          'alpha-brd': 'value',
          bg: 'value',
          'boxShadowToggleOn-shd': 'value',
          brd: 'value',
          brw: 'value',
          shd: 'value',
        },
        groups: {},
      },
      componentClassName: 'mobile.core.components.Container',
      pageId: '',
      compId: '',
      styleType: 'custom',
      skin: 'wysiwyg.viewer.skins.area.CircleArea',
    },
  },
  style: {
    type: 'ComponentStyle',
    metaData: {
      isPreset: false,
      schemaVersion: '1.0',
      isHidden: false,
      pageId: 'ik4zq',
    },
    style: {
      properties: {
        'alpha-bg': '1',
        'alpha-brd': '1',
        bg: 'rgba(254,196,195,1)',
        'boxShadowToggleOn-shd': 'false',
        brd: '#F75E5E',
        brw: '0',
        shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
      },
      propertiesSource: {
        'alpha-bg': 'value',
        'alpha-brd': 'value',
        bg: 'value',
        'boxShadowToggleOn-shd': 'value',
        brd: 'value',
        brw: 'value',
        shd: 'value',
      },
      groups: {},
    },
    componentClassName: 'mobile.core.components.Container',
    pageId: '',
    compId: '',
    styleType: 'custom',
    skin: 'wysiwyg.viewer.skins.area.CircleArea',
  },
  mobileStructure: {
    layout: {
      width: 100,
      height: 100,
      x: 110,
      y: 10,
      scale: 1,
      rotationInDegrees: 0,
      fixedPosition: false,
    },
    metaData: {
      originalCompId: 'comp-kgt64g51',
      author: 'studio',
    },
  },
  activeModes: {},
};
